export var textNodes = function(node) {
    var all = [];
    for(node = node === null || node === void 0 ? void 0 : node.firstChild; node; node = node.nextSibling){
        if (node.nodeType === 3) {
            all.push(node);
        } else {
            all = all.concat(textNodes(node));
        }
    }
    return all;
};
export var textNodesByTag = function(node, tag) {
    var all = [];
    for(node = node === null || node === void 0 ? void 0 : node.firstChild; node; node = node.nextSibling){
        if (node.nodeType === 3) {
            all.push(node);
        } else {
            all = all.concat(textNodes(node));
        }
    }
    return all.filter(function(node) {
        var ref;
        return node === null || node === void 0 ? void 0 : (ref = node.textContent) === null || ref === void 0 ? void 0 : ref.includes("<".concat(tag, ">"));
    });
};
export var findUpTag = function(el, tag) {
    while(el.parentNode){
        el = el.parentNode;
        if (el.nodeName.toLowerCase() === tag) {
            return el;
        }
    }
    return null;
};
// Find an element in all of the elm's children that satisfies predicate
export var getChild = function(elm, predicate) {
    return predicate(elm) && elm || Array.from(elm.children).find(function(v) {
        return getChild(v, predicate);
    });
};
export var insertAfter = function(referenceNode, newNode) {
    var ref;
    referenceNode === null || referenceNode === void 0 ? void 0 : (ref = referenceNode.parentNode) === null || ref === void 0 ? void 0 : ref.insertBefore(newNode, referenceNode.nextSibling);
};
export var inlineText = function(content) {
    var fontSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 11, fontFamily = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "'Calibri', candara, segoe, 'segoe ui', optima, sans-serif";
    return '<span style="font-size: '.concat(fontSize, "pt; font-family: ").concat(fontFamily, ';">').concat(content, "</span>");
};
